window.Cell = function() {
    var el = this;
    var isMoving = false;
    var isResizing = false;
    var isRotating = false;
    var elsList = {};
    var copyCellItem = false;
    var copyCellInfo = false;
    var copyImageItem = false;

    el.lastBorderAttributes = {};

    var alignmentsOx = {};
    var alignmentsOy = {};
    el.alignments = [];

    el.cutArea = {x: 0, y: 0, width: 0, height: 0};

    function initAlignments()
    {
        var i;
        var cells = el.workData.workareas[el.selectWorkareaId].format.cells;
        alignmentsOx = {};
        alignmentsOy = {};

        for (i in cells) {
            if (i !== el.selectId && cells[i] !== null) {
                alignmentsOx[cells[i].border_x] = true;
                alignmentsOx[parseInt(cells[i].border_x) + parseInt(cells[i].border_width)] = true;
                alignmentsOy[cells[i].border_y] = true;
                alignmentsOy[parseInt(cells[i].border_y) + parseInt(cells[i].border_height)] = true;
            }
        }
    }

    function checkAlignments(pos)
    {
        el.alignments = [];

        if (alignmentsOx.hasOwnProperty(pos.x)) {
            el.alignments.x = true;
        }

        if (alignmentsOx.hasOwnProperty(pos.x + pos.width)) {
            el.alignments.width = true;
        }

        if (alignmentsOy.hasOwnProperty(pos.y)) {
            el.alignments.y = true;
        }

        if (alignmentsOy.hasOwnProperty(pos.y + pos.height)) {
            el.alignments.height = true;
        }
    }

    function hideAlignments()
    {
        if (el.selectType === 'cell') {
            $('#alignment-x').attr('stroke-width', 0);
            $('#alignment-width').attr('stroke-width', 0);
            $('#alignment-y').attr('stroke-width', 0);
            $('#alignment-height').attr('stroke-width', 0);
        }
    }

    el.getCountEmptyCells = function() {
        var count = 0;
        var workareas = el.workData.workareas;
        var format, image;
        for (var workareaId in workareas) {
            format = workareas[workareaId].format;
            for (var cellId in format.cells) {
                if (!format.hasOwnProperty('images') || !format.images.hasOwnProperty(cellId)) {
                    count++;
                    continue;
                }

                image = format.images[cellId];
                if (image.type === 'template') {
                    count++;
                }
            }
        }

        return count;
    };

    el.add = function() {
        if (el.isLocked()) {
            return false;
        }

        var format = el.workData.workareas[el.selectWorkareaId].format;
        var keys = Object.keys(format.cells);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        var viewWidth = parseInt(el.WORKAREA_WIDTH);
        var viewHeight = parseInt(el.WORKAREA_WIDTH * format.height / format.width);
        var width = parseInt(viewWidth / 2);
        var height = parseInt(viewHeight / 2);

        var cell = {
            border_width: width,
            border_height: height,
            border_x: parseInt((viewWidth - width) / 2),
            border_y: parseInt((viewHeight - height) / 2),
            border_color: '#ffffff',
            border_shadow: 0,
            border_opacity: 0,
            width: width,
            height: height,
            x: parseInt((viewWidth - width) / 2),
            y: parseInt((viewHeight - height) / 2),
        };

        if (Object.keys(el.lastBorderAttributes).length > 0) {
            cell = el.borderCell.updateData(el.lastBorderAttributes, cell);
        }

        var image = el.workData.workareas[el.selectWorkareaId].format.images[number];
        if (image !== null && image !== undefined) {
            var pos = {
                x: cell.x,
                y: cell.y,
                width: cell.width,
                height: cell.height,
            };
            pos = el.upImages.setImagePosition(image.data_width, image.data_height, pos);
            image.x = pos.x;
            image.y = pos.y;
            image.width = pos.width;
            image.height = pos.height;
        }

        el._parent.workData.workareas[el.selectWorkareaId].format.cells[number] = cell;

        el.layer.add(el.selectWorkareaId, 'cells', number);

        el.workarea.render();
        el.preview.update();

        el.history.add();
    };

    el.addWithImage = function() {
        el.add();
        var format = el.workData.workareas[el.selectWorkareaId].format;
        var keys = Object.keys(format.cells);
        var number = parseInt(keys[keys.length - 1]);

        el.upImages.drop('images', el.selectWorkareaId, number, null, function() {
            var cell = el._parent.workData.workareas[el.selectWorkareaId].format.cells[number];
            var image = el._parent.workData.workareas[el.selectWorkareaId].format.images[number];

            var format = el.workData.workareas[el.selectWorkareaId].format;
            var viewWidth = parseInt(el.WORKAREA_WIDTH);
            var viewHeight = parseInt(el.WORKAREA_WIDTH * format.height / format.width);

            var imageWidth = image.data_width;
            var imageHeight = image.data_height;

            if (imageWidth > imageHeight) {
                var width = parseInt(viewWidth / 2);
                var height = parseInt(width * imageHeight / imageWidth);
                cell.width = width;
                cell.border_width = width;
                cell.border_x = parseInt((viewWidth - width) / 2);
                cell.x = parseInt((viewWidth - width) / 2);
                cell.height = height;
                cell.border_height = height;
                cell.border_y = parseInt((viewHeight - height) / 2);
                cell.y = parseInt((viewHeight - height) / 2);
            } else {
                var height = parseInt(viewHeight / 2);
                var width = parseInt(height * imageWidth / imageHeight);
                cell.width = width;
                cell.border_width = width;
                cell.border_x = parseInt((viewWidth - width) / 2);
                cell.x = parseInt((viewWidth - width) / 2);
                cell.height = height;
                cell.border_height = height;
                cell.border_y = parseInt((viewHeight - height) / 2);
                cell.y = parseInt((viewHeight - height) / 2);
            }

            el.upImages.reinitImagePosition(el.selectWorkareaId, 'cell', number);

            el.workarea.render();
            el.preview.update();

            el.history.add();
        });
    };

    el.copy = function() {
        var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;

        copyCellItem = reversal.cells[el.selectId];
        
        copyCellInfo = {
            workarea_width : reversal.width,
            workarea_height : reversal.height,
            workarea_id : el.selectWorkareaId,
        }
        
        copyImageItem = false;

        if (reversal.hasOwnProperty('images') && reversal.images.hasOwnProperty(el.selectId)) {
            copyImageItem = reversal.images[el.selectId];
        }
    };

    el.paste = function() {
        if (el.isLocked()) {
            return false;
        }

        var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
        var keys = Object.keys(reversal.cells);
        var number = 1;
        if (keys.length > 0) {
            number = parseInt(keys[keys.length - 1]) + 1;
        }

        copyCellItem = copyCellItem || reversal.cells[el.selectId];

        if (typeof(copyCellItem) === 'undefined') {
            return;
        }

        var cell = $.extend(true, {}, copyCellItem);

        if (copyCellInfo.workarea_height == reversal.height && copyCellInfo.workarea_width == reversal.width 
            && copyCellInfo.workarea_id !== el.selectWorkareaId ) {
            cell.border_x = copyCellItem.border_x;
            cell.border_y = copyCellItem.border_y;
            cell.x = copyCellItem.x;
            cell.y = copyCellItem.y;
        } else {
            cell.border_x = parseInt((reversal.width - cell.border_width) / 2);
            cell.border_y = parseInt((reversal.height - cell.border_height) / 2);
            cell.x = parseInt((reversal.width - cell.width) / 2);
            cell.y = parseInt((reversal.height - cell.height) / 2);
        }

        reversal.cells[number] = cell;
        el.layer.add(el.selectWorkareaId, 'cells', number);

        if (copyImageItem === false && reversal.hasOwnProperty('images') &&
            reversal.images.hasOwnProperty(el.selectId)) {
            copyImageItem = reversal.images[el.selectId];
        }

        if (copyImageItem) {
            var image = $.extend(true, {}, copyImageItem);
            reversal.images[number] = image;
            el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, number);
        }

        copyCellItem = false;
        copyImageItem = false;

        el.workarea.render();
        el.preview.update();

        el.history.add();
    };

    el.remove = function() {
        if (el.isLocked()) {
            return false;
        }

        var reversal = el.workData.workareas[el.selectWorkareaId].format;
        var element = el.svgRoot.getElementById(
            'grid-cell-' + el.selectWorkareaId + '-' + el.selectId);
        element.parentNode.removeChild(element);

        if (reversal.images.hasOwnProperty(el.selectId)) {
            el.upImages.unsetUsedImage(reversal.images[el.selectId].name);
            delete reversal.images[el.selectId];
        }

        delete reversal.cells[el.selectId];
        el.layer.remove(el.selectWorkareaId, 'cells', el.selectId);

        el.selection.hide();
        el.history.add();
    };

    el.beginMove = function() {
        isMoving = true;
        el._parent.isTransforming = true;
        el._parent.svgRoot = document.getElementById('constructor-hardcover');

        elsList = {
            elements: [],
            coords: [],
            lastX: 0,
            lastY: 0,
            x: 0,
            y: 0,
            parent: false,
        };

        var elementsList = [
            'border-item-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-clippath-rect-' + el.selectWorkareaId + '-' + el.selectId,
            'images-item-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-bg-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-image-add-btn-' + el.selectWorkareaId + '-' + el.selectId,
            'mask-image-' + el.selectWorkareaId + '-' + el.selectId,
            'border-image-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-item-' + el.selectWorkareaId + '-' + el.selectId,
        ];

        var i, element;
        for (i = 0; i < elementsList.length; i++) {
            element = el.svgRoot.getElementById(elementsList[i]);
            if (element) {
                elsList.elements.push(element);
                elsList.coords.push(el.transform.getPosition(element));

                if (element.getAttribute('class') === 'border') {
                    element.removeAttribute('filter');
                }
            }
        }

        elsList.parent = elsList.elements[0].parentNode;

        initAlignments();
    };

    el.move = function(event, keyMovement) {
        if (el.isLocked()) {
            return false;
        }

        if (isMoving) {
            var movementX = 0;
            var movementY = 0;

            if(!keyMovement) {
                if (event.originalEvent.touches !== undefined) {
                    event.preventDefault();
                    movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX -
                        elsList.lastX;
                    movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY -
                        elsList.lastY;
                    elsList.lastX = event.originalEvent.touches[0].pageX;
                    elsList.lastY = event.originalEvent.touches[0].pageY;

                } else {
                    movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                    movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                    elsList.lastX = event.clientX;
                    elsList.lastY = event.clientY;
                }

                movementX /= el.workarea.workAreaScale;
                movementY /= el.workarea.workAreaScale;
            } else {
                movementX = keyMovement.X;
                movementY = keyMovement.Y;
            }
           
            elsList.x += movementX;
            elsList.y += movementY;

            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var elements = elsList.elements;
            var parent = elsList.parent;

            var parentTransform = el.transform.deleteRotate(parent);

            var i, elsPos = {};
            for (i = 0; i < elements.length; i++) {
                elsPos[i] = {
                    x: parseInt(elsList.coords[i].x + elsList.x),
                    y: parseInt(elsList.coords[i].y + elsList.y),
                    width: elsList.coords[i].width,
                    height: elsList.coords[i].height,
                };

                el.transform.setPosition(elements[i], elsPos[i].x, elsPos[i].y);
            }

            // set rotate of element
            if (parentTransform.angle !== 0) {
                el.transform.setRotate(parent, parentTransform.angle);
            }

            checkAlignments(elsPos[0]);

            // set new position for el.workData
            reversal.cells[el.selectId].x = elsPos[1].x;
            reversal.cells[el.selectId].y = elsPos[1].y;
            reversal.cells[el.selectId].border_x = elsPos[0].x;
            reversal.cells[el.selectId].border_y = elsPos[0].y;

            var rotate = el.transform.getRotate(parent);
            reversal.cells[el.selectId].rotate_angle = rotate.angle;
            reversal.cells[el.selectId].rotate_x = rotate.x;
            reversal.cells[el.selectId].rotate_y = rotate.y;

            // detect transform for image
            if (reversal.images.hasOwnProperty(el.selectId)) {
                reversal.images[el.selectId].x = elsPos[2].x;
                reversal.images[el.selectId].y = elsPos[2].y;

                var rotate = el.transform.getRotate(elements[2]);
                reversal.images[el.selectId].rotate_angle = rotate.angle;
                reversal.images[el.selectId].rotate_x = rotate.x;
                reversal.images[el.selectId].rotate_y = rotate.y;
            }

            el.selection.update(elements[0]);
        }
    };

    el.endMove = function() {
        if (isMoving) {
            isMoving = false;
            var urlFilter = 'url(#shadow-cell-' + el.selectWorkareaId + '-' + el.selectId + ')';
            elsList.elements[0].setAttribute('filter', urlFilter);
            //hideAlignments();
            el.history.add();
        }
    };

    function updateResizingData(coords)
    {
        var cell = el._parent.workData.workareas[el.selectWorkareaId].format.cells[el.selectId];
        var items = elsList.elements;

        // update position for viewer
        for (var i = 0; i < items.length; i++) {
            items[i].setAttribute('x', coords[i].x);
            items[i].setAttribute('y', coords[i].y);
            items[i].setAttribute('width', coords[i].width);
            items[i].setAttribute('height', coords[i].height);
        }

        // update image position
        var images = el._parent.workData.workareas[el.selectWorkareaId].format.images;
        if (images.hasOwnProperty(el.selectId)) {
            var image = images[el.selectId];
            var imageElement = el.svgRoot.getElementById(
                'images-item-' + el.selectWorkareaId + '-' + el.selectId);

            el.upImages.reinitImagePosition(el.selectWorkareaId, el.selectType, el.selectId);

            imageElement.setAttribute('x', image.x);
            imageElement.setAttribute('y', image.y);
            imageElement.setAttribute('width', image.width);
            imageElement.setAttribute('height', image.height);

            var rotate = el.transform.getRotate(imageElement);
            el.transform.setRotate(imageElement, rotate.angle);
            image.rotate_angle = rotate.angle;
            image.rotate_x = rotate.x;
            image.rotate_y = rotate.y;
        }

        checkAlignments(coords[0]);

        // update position for el.workData
        cell.border_x = coords[0].x;
        cell.border_y = coords[0].y;
        cell.border_width = coords[0].width;
        cell.border_height = coords[0].height;
        cell.x = coords[1].x;
        cell.y = coords[1].y;
        cell.width = coords[1].width;
        cell.height = coords[1].height;

        el.selection.update(items[0]);
    }

    /**
     *
     * @param {Event} event
     * @param {string} type
     */
    el.beginResize = function(event, type) {
        if (event) {
            event.preventDefault()
        }

        isResizing = true;
        el._parent.isTransforming = true;
        el._parent.svgRoot = document.getElementById('constructor-hardcover');

        elsList = {
            elements: [],
            coords: [],
            lastX: 0,
            lastY: 0,
            type: type,
            x: 0,
            y: 0,
        };

        var elementsList = [
            'border-item-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-clippath-rect-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-bg-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-image-add-btn-' + el.selectWorkareaId + '-' + el.selectId,
            'mask-image-' + el.selectWorkareaId + '-' + el.selectId,
            'border-image-' + el.selectWorkareaId + '-' + el.selectId,
            'cell-item-' + el.selectWorkareaId + '-' + el.selectId,
        ];

        var i, element;
        for (i = 0; i < elementsList.length; i++) {
            element = el.svgRoot.getElementById(elementsList[i]);
            if (element) {
                elsList.elements.push(element);
                elsList.coords.push(el.transform.getPosition(element));

                if (element.getAttribute('class') === 'border') {
                    element.removeAttribute('filter');
                }
            }
        }

        elsList.parent = elsList.elements[0].parentNode;

        initAlignments();
    };

    el.resize = function(event) {
        if (el.isLocked()) {
            return false;
        }

        if (isResizing) {
            var movementX = 0;
            var movementY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                movementX = elsList.lastX === 0 ? 0 : event.originalEvent.touches[0].pageX -
                    elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.originalEvent.touches[0].pageY -
                    elsList.lastY;
                elsList.lastX = event.originalEvent.touches[0].pageX;
                elsList.lastY = event.originalEvent.touches[0].pageY;
            } else {
                movementX = elsList.lastX === 0 ? 0 : event.clientX - elsList.lastX;
                movementY = elsList.lastY === 0 ? 0 : event.clientY - elsList.lastY;
                elsList.lastX = event.clientX;
                elsList.lastY = event.clientY;
            }

            var items = elsList.elements;
            var coords = [];
            var minSize = 100;

            movementX /= el.workarea.workAreaScale;
            movementY /= el.workarea.workAreaScale;
            elsList.x += movementX;
            elsList.y += movementY;

            var i;
            for (i = 0; i < items.length; i++) {
                coords[i] = $.extend(true, {}, elsList.coords[i]);

                switch (elsList.type) {
                    case 'width':
                        coords[i].width = parseInt(elsList.coords[i].width + elsList.x);
                        break;
                    case 'height':
                        coords[i].height = parseInt(elsList.coords[i].height + elsList.y);
                        break;
                    case 'x':
                        coords[i].x = parseInt(elsList.coords[i].x + elsList.x);
                        coords[i].width = parseInt(elsList.coords[i].width - elsList.x);
                        break;
                    case 'y':
                        coords[i].y = parseInt(elsList.coords[i].y + elsList.y);
                        coords[i].height = parseInt(elsList.coords[i].height - elsList.y);
                        break;
                    case 'nw':
                        coords[i].x = parseInt(elsList.coords[i].x + elsList.x);
                        coords[i].width = parseInt(elsList.coords[i].width - elsList.x);
                        coords[i].y = parseInt(elsList.coords[i].y + elsList.y);
                        coords[i].height = parseInt(elsList.coords[i].height - elsList.y);
                        break;
                    case 'ne':
                        coords[i].width = parseInt(elsList.coords[i].width + elsList.x);
                        coords[i].y = parseInt(elsList.coords[i].y + elsList.y);
                        coords[i].height = parseInt(elsList.coords[i].height - elsList.y);
                        break;
                    case 'se':
                        coords[i].width = parseInt(elsList.coords[i].width + elsList.x);
                        coords[i].height = parseInt(elsList.coords[i].height + elsList.y);
                        break;
                    case 'sw':
                        coords[i].x = parseInt(elsList.coords[i].x + elsList.x);
                        coords[i].width = parseInt(elsList.coords[i].width - elsList.x);
                        coords[i].height = parseInt(elsList.coords[i].height + elsList.y);
                        break;
                }
            }

            // check size cell
            if (
                coords[0].width < minSize
                || coords[0].height < minSize
            //   || coords[0].width > el.workData.width
            //   || coords[0].height > el.workData.height
            ) {
                return false;
            }

            updateResizingData(coords);
        }
    };

    el.resizeFromBalloon = function() {
        if (el.isLocked()) {
            return false;
        }

        el.beginResize();

        var newCoords = {
            x: $('#coord-x').val(),
            y: $('#coord-y').val(),
            width: $('#coord-width').val(),
            height: $('#coord-height').val(),
        };
        var coords = [];
        var cell = el._parent.workData.workareas[el.selectWorkareaId].format.cells[el.selectId];
        var items = elsList.elements;

        var diff = {
            x: newCoords.x - cell.x,
            y: newCoords.y - cell.y,
            width: newCoords.width - cell.width,
            height: newCoords.height - cell.height,
        };

        for (var i = 0; i < items.length; i++) {
            coords[i] = el.transform.getPosition(items[i]);

            coords[i].x += diff.x;
            coords[i].y += diff.y;
            coords[i].width += diff.width;
            coords[i].height += diff.height;
        }

        updateResizingData(coords);

        el.endResize();
    };

    el.endResize = function() {
        if (isResizing) {
            isResizing = false;
            var urlFilter = 'url(#shadow-cell-' + el.selectWorkareaId + '-' + el.selectId + ')';
            elsList.elements[0].setAttribute('filter', urlFilter);
            hideAlignments();
            el.history.add();
        }
    };

    /**
     *
     * @param {Event} event
     */
    el.beginRotate = function(event) {
        event.preventDefault();
        isRotating = true;
        el._parent.isTransforming = true;
        el._parent.svgRoot = document.getElementById('constructor-hardcover');

        var element = el.svgRoot.getElementById(
            'border-item-' + el.selectWorkareaId + '-' + el.selectId);
        var pos = el.transform.getPosition(element);

        elsList = {
            element: element.parentNode,
            child: element,
            coords: {
                centerX: pos.x + (pos.width / 2),
                centerY: pos.y + (pos.height / 2),
            },
        };

        element.removeAttribute('filter');
    };

    el.rotate = function(event) {
        if (el.isLocked()) {
            return false;
        }

        if (isRotating) {
            var element = elsList.element;
            var pos = elsList.coords;

            var workAreaScale = el.workarea.workAreaScale;

            var offsetX = 0;
            var offsetY = 0;

            if (event.originalEvent.touches !== undefined) {
                event.preventDefault();
                var offsetPos = document.getElementById(
                    'backgrounds-rect-' + el.selectWorkareaId + '-1').getBoundingClientRect();
                offsetX = event.originalEvent.touches[0].clientX - offsetPos.left;
                offsetY = event.originalEvent.touches[0].clientY - offsetPos.top;
            } else {
                var offsetPos = document.getElementById(
                    'backgrounds-rect-' + el.selectWorkareaId + '-1').getBoundingClientRect();
                offsetX = event.clientX - offsetPos.left;
                offsetY = event.clientY - offsetPos.top;
            }

            var dx = pos.centerX * workAreaScale - offsetX;
            var dy = pos.centerY * workAreaScale - offsetY;
            var angle = Math.atan2(dy, dx) * 180 / Math.PI - 90;

            el.transform.setRotate(element, angle, elsList.coords.centerX, elsList.coords.centerY);

            // set new transform property for el.workData;
            var reversal = el._parent.workData.workareas[el.selectWorkareaId].format;
            var rotate = el.transform.getRotate(element);
            reversal.cells[el.selectId].rotate_angle = rotate.angle;
            reversal.cells[el.selectId].rotate_x = elsList.coords.centerX;
            reversal.cells[el.selectId].rotate_y = elsList.coords.centerY;

            el.selection.update(elsList.child);
        }
    };

    el.endRotate = function() {
        if (isRotating) {
            isRotating = false;
            var urlFilter = 'url(#shadow-cell-' + el.selectWorkareaId + '-' + el.selectId + ')';
            elsList.child.setAttribute('filter', urlFilter);
            el.history.add();
        }
    };

    el.isLocked = function () {
        if (!el._parent.hasOwnProperty('project')) {
            return false;
        }

        var project = el.project.current;
        if (project.template_id === null) {
            return false;
        }

        var template = el.template.get(project.template_id);
        if (template === false) {
            return false;
        }

        if (parseInt(template.lock_cells) !== 1) {
            return false;
        }

        return true;
    };

    $('.js-cell-add').on('click', function() {
        el.add();
    });

    $('.js-coord-input').on('change', function() {
        if (el.selectType === 'cell') {
            el.resizeFromBalloon();
        }
    });
};
